import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faTools,
    faHome,
    faUser,
    faSignOutAlt,
    faCog, faGamepad, faBook,
    faExpand, faCompress,
    faArrowsAltH, faCompressArrowsAlt
} from '@fortawesome/free-solid-svg-icons'
import styles from './MainMenu.module.scss';
import Navigation from "../Navigation/Navigation";
import MobileNav from "../MobileNav/MobileNav";
import Search from "../Search/Search";
import Clock from "../Clock/Clock";
import {useAuth} from '../../contexts/AuthContext';
import eventBus from "../../utils/EventBus";
import Login from "../../Components/Login";

export default function MainMenu(props) {
    const navigate = useNavigate();
    const {user, impersonation, logout} = useAuth();
    // const [verticalClock, setVerticalClock] = useState(window.innerWidth <= 600);
    const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);

    const handleSearchSelect = (result) => {
        props.selectPages(result.section)
        navigate(result.to)
    }

    const selectLocation = function (location) {
        switch (location) {
            case 'home':
                props.selectPages('home')
                navigate('/')
                break
            case 'utilities':
                props.selectPages('utilities')
                navigate('/utilities')
                break
            case 'games':
                props.selectPages('games')
                navigate('/games')
                break
            case 'pages':
                props.selectPages('pages')
                navigate('/pages')
                break
            case 'dashboard':
                navigate('/dashboard')
                break
            default:
                throw new Error('Unexpected location')
        }
    }

    const handleLoginClick = () => {
        eventBus.publish('modal',
            {
                title: "Login",
                content: <Login/>
            })
    }

    const handleLogout = () => {
        logout();
        navigate('/');
    }

    const toggleFullscreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            document.documentElement.requestFullscreen();
        }
    }

    const iconStyles = {
        width: '30px',
        height: '30px',
        margin: '10px',
        cursor: 'pointer'
    }

    function debounce(fn, ms) {
        let timer
        return _ => {
            clearTimeout(timer)
            timer = setTimeout(_ => {
                timer = null
                fn.apply(this, arguments)
            }, ms)
        };
    }

    useEffect(() => {
        const debouncedHandleResize = debounce(() => {
            console.log('resize')
            // setVerticalClock(window.innerWidth <= 650)
        }, 100)

        window.addEventListener('resize', debouncedHandleResize)
        return () => window.removeEventListener('resize', debouncedHandleResize);
    })

    useEffect(() => {
        const handleFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement)

        document.addEventListener('fullscreenchange', handleFullscreenChange)
        return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
    }, [])

    return (
        <div className={`${styles.header} ${props.isFullWidth ? styles.fullWidth : ''}`}>
            {/* Group 1: Context Switching */}
            <div className={`${styles.group} ${styles.left}`}>
                <FontAwesomeIcon style={iconStyles}
                                 onClick={() => selectLocation('home')}
                                 icon={faHome}
                                 title="Home"/>
                <FontAwesomeIcon style={iconStyles}
                                 onClick={() => selectLocation('pages')}
                                 icon={faBook}
                                 title="Documentation"/>
                <FontAwesomeIcon style={iconStyles}
                                 onClick={() => selectLocation('utilities')}
                                 icon={faTools}
                                 title="Utilities"/>
                {user ? <FontAwesomeIcon
                    style={iconStyles}
                    onClick={() => selectLocation('games')}
                    icon={faGamepad}
                    title="Games"
                /> : null}
                <Search onSelect={handleSearchSelect}/>
            </div>

            {/* Group 2: Main Navigation */}
            <div className={`${styles.group} ${styles.center}`}>
                <Navigation {...props}/>
                <MobileNav pages={props.pages}/>
            </div>

            {/* Group 3: User Authentication */}
            <div className={`${styles.group} ${styles.right}`}>
                {user ? (
                    <>
                        {user.is_admin && (
                            <FontAwesomeIcon
                                style={iconStyles}
                                onClick={() => navigate('/admin')}
                                icon={faCog}
                                title="Admin"
                            />
                        )}
                        <FontAwesomeIcon
                            style={iconStyles}
                            onClick={() => selectLocation('dashboard')}
                            icon={faUser}
                            title={`Logged in as ${impersonation ? impersonation.targetUsername : user.username}${impersonation ? ' (impersonating)' : ''}`}
                        />
                        <FontAwesomeIcon
                            style={iconStyles}
                            onClick={handleLogout}
                            icon={faSignOutAlt}
                            title="Logout"
                        />
                    </>
                ) : (
                    <FontAwesomeIcon
                        style={iconStyles}
                        onClick={handleLoginClick}
                        icon={faUser}
                        title="Login"
                    />
                )}
            </div>

            <div className={styles.clockArea}>
                <Clock clockClass={styles.clock}/>
                <div className={styles.toggleGroup}>
                    <FontAwesomeIcon
                        className={styles.fullscreenToggle}
                        onClick={toggleFullscreen}
                        icon={isFullscreen ? faCompress : faExpand}
                        title={isFullscreen ? 'Exit full screen' : 'Full screen'}
                    />
                    <FontAwesomeIcon
                        className={styles.fullWidthToggle}
                        onClick={props.onToggleFullWidth}
                        icon={props.isFullWidth ? faCompressArrowsAlt : faArrowsAltH}
                        title={props.isFullWidth ? 'Exit full width' : 'Full width'}
                    />
                </div>
            </div>
        </div>
    );
}
